import React from "react";
import { Link } from "react-router-dom";
import { FaWhatsapp, FaCheckCircle, FaRegClock, FaChartBar, FaBell, FaUserShield, FaRocket } from "react-icons/fa";
var testimonials = [
    {
        name: "Ana Souza",
        role: "Gestora de Tráfego",
        text: "O Vision Cockpit me economiza horas por semana e me permite atender mais clientes sem perder qualidade.",
        avatar: "/static/frontend/img/avatar-ana.png",
    },
    {
        name: "Lucas Pereira",
        role: "Sócio na Agência Rocket",
        text: "A configuração é realmente simples. Em minutos já estava monitorando meus clientes e recebendo alertas no WhatsApp.",
        avatar: "/static/frontend/img/avatar-lucas.png",
    },
    {
        name: "Marina Lima",
        role: "Analista de Performance",
        text: "O plano gratuito já resolve para clientes pequenos. Recomendo para qualquer agência que quer escalar.",
        avatar: "/static/frontend/img/avatar-marina.png",
    },
];
var features = [
    {
        icon: React.createElement(FaBell, { className: "w-8 h-8 text-yellow-400" }),
        title: "Alertas Inteligentes",
        desc: "Receba avisos automáticos sobre saldo, desempenho e oportunidades para nunca deixar seus clientes na mão.",
    },
    {
        icon: React.createElement(FaChartBar, { className: "w-8 h-8 text-blue-400" }),
        title: "Dashboards Unificados",
        desc: "Visualize Google Ads, Facebook Ads e Instagram em uma única tela, com atualização automática.",
    },
    {
        icon: React.createElement(FaWhatsapp, { className: "w-8 h-8 text-green-400" }),
        title: "Notificações no WhatsApp",
        desc: "Configure alertas para receber no seu celular e agir rápido quando algo importante acontecer.",
    },
    {
        icon: React.createElement(FaRegClock, { className: "w-8 h-8 text-cyan-400" }),
        title: "Atualização Frequente",
        desc: "Dados atualizados automaticamente a cada 1h, 30min ou 5min, conforme seu plano.",
    },
    {
        icon: React.createElement(FaUserShield, { className: "w-8 h-8 text-pink-400" }),
        title: "Privacidade e Segurança",
        desc: "Seus dados e de seus clientes protegidos com criptografia e autenticação segura.",
    },
    {
        icon: React.createElement(FaRocket, { className: "w-8 h-8 text-purple-400" }),
        title: "Escalabilidade Real",
        desc: "Comece grátis para 1 cliente e escale para dezenas sem complicação ou burocracia.",
    },
];
var faqs = [
    {
        q: "O Vision Cockpit é realmente gratuito?",
        a: "Sim! O plano gratuito é vitalício para monitoramento de 1 cliente. Você pode usar sem limite de tempo.",
    },
    {
        q: "Como funciona o teste grátis dos planos pagos?",
        a: "Você pode testar qualquer plano pago por 7 dias. Se não gostar, basta cancelar e seu dinheiro será reembolsado.",
    },
    {
        q: "Quais plataformas posso monitorar?",
        a: "Google Ads, Facebook Ads e Instagram. Novas integrações serão lançadas em breve.",
    },
    {
        q: "Como funciona o suporte?",
        a: "Nosso suporte é via WhatsApp e e-mail, com atendimento rápido para todos os planos.",
    },
    {
        q: "Posso migrar do plano gratuito para um pago a qualquer momento?",
        a: "Sim! Basta escolher o novo plano e a migração é instantânea, sem perder dados.",
    },
];
var plans = [
    {
        name: "Gratuito",
        price: "R$ 0",
        period: "para sempre",
        features: [
            "1 cliente monitorado",
            "Dashboards e alertas básicos",
            "Atualização a cada 12h",
            "Suporte por e-mail",
        ],
        cta: "Começar grátis",
        highlight: false,
    },
    {
        name: "Profissional",
        price: "R$ 49",
        period: "mensal",
        features: [
            "Até 10 clientes",
            "Dashboards avançados",
            "Alertas inteligentes",
            "Atualização a cada 1h",
            "Notificações WhatsApp",
            "Suporte prioritário",
        ],
        cta: "Quero escalar",
        highlight: false,
    },
    {
        name: "Agência",
        price: "R$ 490",
        period: "anual",
        features: [
            "Clientes ilimitados",
            "Dashboards completos",
            "Alertas e automações",
            "Atualização a cada 5min",
            "Notificações WhatsApp",
            "Suporte VIP",
            "2 meses grátis (desconto 15%)",
        ],
        cta: "Aproveitar desconto anual",
        highlight: true,
        badge: "Mais vantajoso",
    },
];
var LandingPage2 = function () {
    return (React.createElement("div", { className: "bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white min-h-screen" },
        React.createElement("section", { className: "py-16 px-4 flex flex-col items-center text-center" },
            React.createElement("h1", { className: "text-4xl md:text-5xl font-extrabold mb-6" },
                "Automatize o sucesso da sua ag\u00EAncia ",
                React.createElement("span", { className: "text-green-400" }, "sem burocracia")),
            React.createElement("p", { className: "text-xl text-gray-300 mb-8 max-w-2xl" }, "Crie sua conta, conecte clientes e plataformas, e comece a monitorar em menos de 2 minutos. Plano gratuito vital\u00EDcio para 1 cliente!"),
            React.createElement(Link, { to: "/register", className: "px-10 py-4 rounded-2xl bg-gradient-to-r from-green-500 to-blue-500 text-white font-extrabold text-2xl shadow-2xl hover:from-green-600 hover:to-blue-600 transition-all duration-300 animate-bounce" }, "Come\u00E7ar agora")),
        React.createElement("section", { className: "max-w-6xl mx-auto mt-10 px-4" },
            React.createElement("h2", { className: "text-3xl font-bold text-green-400 mb-8 text-center" }, "Funcionalidades principais"),
            React.createElement("div", { className: "grid grid-cols-1 md:grid-cols-3 gap-8" }, features.map(function (f, i) { return (React.createElement("div", { key: i, className: "bg-gray-800/80 rounded-xl p-8 flex flex-col items-center shadow-lg border border-green-400/10" },
                f.icon,
                React.createElement("h3", { className: "text-xl font-bold mt-4 mb-2 text-green-200" }, f.title),
                React.createElement("p", { className: "text-gray-300 text-center" }, f.desc))); })),
            React.createElement("div", { className: "flex justify-center mt-10" },
                React.createElement(Link, { to: "/register", className: "px-8 py-3 rounded-xl bg-gradient-to-r from-green-500 to-blue-500 text-white font-bold text-xl shadow-lg hover:from-green-600 hover:to-blue-600 transition-all duration-300" }, "Come\u00E7ar agora"))),
        React.createElement("section", { className: "max-w-5xl mx-auto mt-20 px-4" },
            React.createElement("h2", { className: "text-3xl font-bold text-green-400 mb-8 text-center" }, "O que dizem nossos clientes"),
            React.createElement("div", { className: "grid grid-cols-1 md:grid-cols-3 gap-8" }, testimonials.map(function (t, i) { return (React.createElement("div", { key: i, className: "bg-gray-800/80 rounded-xl p-6 flex flex-col items-center shadow border border-green-400/10" },
                React.createElement("img", { src: t.avatar, alt: t.name, className: "w-16 h-16 rounded-full mb-3 border-2 border-green-400" }),
                React.createElement("p", { className: "text-gray-200 text-center mb-3" },
                    "\"",
                    t.text,
                    "\""),
                React.createElement("span", { className: "font-bold text-green-300" }, t.name),
                React.createElement("span", { className: "text-sm text-gray-400" }, t.role))); }))),
        React.createElement("section", { className: "max-w-6xl mx-auto mt-20 px-4" },
            React.createElement("h2", { className: "text-3xl font-bold text-green-400 mb-8 text-center" }, "Escolha seu plano"),
            React.createElement("div", { className: "flex flex-wrap justify-center gap-8" }, plans.map(function (plan, i) { return (React.createElement("div", { key: i, className: "w-[300px] rounded-2xl shadow-xl px-6 py-8 flex flex-col items-center border-4 ".concat(plan.highlight
                    ? "border-yellow-400 bg-gradient-to-br from-yellow-900 via-green-900 to-yellow-900"
                    : "border-cyan-700 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900", " hover:scale-105 transition-transform duration-300 relative") },
                plan.badge && (React.createElement("span", { className: "absolute -top-4 left-1/2 -translate-x-1/2 bg-yellow-400 text-gray-900 font-bold px-4 py-1 rounded-full shadow text-xs" }, plan.badge)),
                React.createElement("h3", { className: "text-xl font-bold mb-2 text-cyan-200" }, plan.name),
                React.createElement("span", { className: "text-3xl font-extrabold mb-2 text-white" },
                    plan.price,
                    React.createElement("span", { className: "text-base font-normal text-gray-300 ml-1" },
                        "/",
                        plan.period)),
                React.createElement("ul", { className: "text-gray-300 text-left mb-4 mt-2 space-y-2" }, plan.features.map(function (f, idx) { return (React.createElement("li", { key: idx, className: "flex items-center gap-2" },
                    React.createElement(FaCheckCircle, { className: "text-green-400" }),
                    " ",
                    f)); })),
                React.createElement(Link, { to: "/register", className: "mt-auto px-6 py-2 rounded-lg bg-gradient-to-r from-green-500 to-blue-500 text-white font-bold shadow-lg transition-all" }, plan.cta))); })),
            React.createElement("div", { className: "text-center mt-8" },
                React.createElement("span", { className: "inline-block bg-yellow-500/20 text-yellow-300 px-4 py-2 rounded-full font-semibold text-lg" }, "Desconto de 15% no plano anual (2 meses gr\u00E1tis)!"))),
        React.createElement("section", { className: "max-w-3xl mx-auto mt-20 px-4 text-center" },
            React.createElement("h2", { className: "text-2xl font-bold text-green-400 mb-4" }, "Teste gr\u00E1tis por 7 dias"),
            React.createElement("p", { className: "text-lg text-gray-200 mb-6" }, "Experimente qualquer plano pago por 7 dias. Se n\u00E3o gostar, devolvemos seu dinheiro sem perguntas!"),
            React.createElement(Link, { to: "/register", className: "px-8 py-3 rounded-xl bg-gradient-to-r from-green-500 to-blue-500 text-white font-bold text-xl shadow-lg hover:from-green-600 hover:to-blue-600 transition-all duration-300" }, "Come\u00E7ar agora")),
        React.createElement("section", { className: "max-w-6xl mx-auto mt-20 px-4 flex flex-col items-center", id: "como-funciona" },
            React.createElement("h2", { className: "text-3xl font-extrabold text-green-400 mb-8 text-center" }, "Como come\u00E7ar em 2 minutos"),
            React.createElement("div", { className: "grid grid-cols-1 md:grid-cols-3 gap-8 w-full" },
                React.createElement("div", { className: "flex flex-col items-center" },
                    React.createElement("img", { src: "/static/frontend/gifs/passo1.gif", alt: "Criar usu\u00E1rio", className: "w-full max-w-[340px] h-auto mb-3 rounded-xl shadow", style: { aspectRatio: "692/388" } }),
                    React.createElement("span", { className: "text-lg font-bold text-blue-300 mb-1" }, "1. Crie seu usu\u00E1rio"),
                    React.createElement("span", { className: "text-gray-300 text-center text-base" }, "Cadastro r\u00E1pido, sem burocracia.")),
                React.createElement("div", { className: "flex flex-col items-center" },
                    React.createElement("img", { src: "/static/frontend/gifs/passo2.gif", alt: "Selecionar clientes", className: "w-full max-w-[340px] h-auto mb-3 rounded-xl shadow", style: { aspectRatio: "692/388" } }),
                    React.createElement("span", { className: "text-lg font-bold text-blue-300 mb-1" }, "2. Selecione os clientes"),
                    React.createElement("span", { className: "text-gray-300 text-center text-base" }, "Logue o Google/Facebook e escolha quem monitorar.")),
                React.createElement("div", { className: "flex flex-col items-center" },
                    React.createElement("img", { src: "/static/frontend/gifs/passo3.gif", alt: "Acesse o monitoramento", className: "w-full max-w-[340px] h-auto mb-3 rounded-xl shadow", style: { aspectRatio: "692/388" } }),
                    React.createElement("span", { className: "text-lg font-bold text-blue-300 mb-1" }, "3. Acesse o monitoramento"),
                    React.createElement("span", { className: "text-gray-300 text-center text-base" }, "Acompanhe todos os clientes com dados sempre atualizados, em uma \u00FAnica tela."))),
            React.createElement(Link, { to: "/register", className: "mt-8 px-10 py-4 rounded-2xl bg-gradient-to-r from-green-500 to-blue-500 text-white font-extrabold text-2xl shadow-2xl hover:from-green-600 hover:to-blue-600 transition-all duration-300" }, "Come\u00E7ar agora")),
        React.createElement("section", { className: "max-w-4xl mx-auto mt-20 px-4" },
            React.createElement("h2", { className: "text-3xl font-bold text-green-400 mb-8 text-center" }, "Perguntas frequentes"),
            React.createElement("div", { className: "space-y-6" }, faqs.map(function (faq, i) { return (React.createElement("div", { key: i, className: "bg-gray-800/80 rounded-xl p-6 shadow border border-green-400/10" },
                React.createElement("h3", { className: "text-lg font-bold text-green-200 mb-2" }, faq.q),
                React.createElement("p", { className: "text-gray-300" }, faq.a))); }))),
        React.createElement("section", { className: "py-16 px-4 flex flex-col items-center text-center mt-20" },
            React.createElement("h2", { className: "text-3xl md:text-4xl font-extrabold mb-6" }, "Pronto para automatizar o sucesso da sua ag\u00EAncia?"),
            React.createElement("p", { className: "text-xl text-gray-300 mb-8 max-w-2xl" }, "Comece gr\u00E1tis agora mesmo e veja como \u00E9 f\u00E1cil monitorar e escalar seus resultados!"),
            React.createElement(Link, { to: "/register", className: "px-10 py-4 rounded-2xl bg-gradient-to-r from-green-500 to-blue-500 text-white font-extrabold text-2xl shadow-2xl hover:from-green-600 hover:to-blue-600 transition-all duration-300 animate-bounce" }, "Come\u00E7ar agora"))));
};
export default LandingPage2;
